import { writable } from 'svelte/store'

export const isMobile = writable()
export const errorBox = writable({ title: '', description: ''})
export const sessionExpiredModalShown = writable(false)
export const locale = writable(localStorage.getItem('locale'))
